import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ConfirmationModal = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonColor
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: theme.palette.background.paper,
          borderRadius: 2,
          width: '90vw',
          maxWidth: 500,
          boxShadow: theme.shadows[6],
          fontFamily: 'Nunito Sans, sans-serif',
          p: 3
        }
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          m: 0,
          p: 0,
          fontSize: 24,
          fontWeight: 700,
          color: theme.palette.text.primary,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        {title}
        <IconButton
          onClick={onCancel}
          sx={{
            color: theme.palette.warning.main,
            p: 0,
            ml: 2
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent sx={{ p: 0, mt: 2 }}>
        <DialogContentText
          sx={{
            fontSize: 16,
            color: theme.palette.text.primary,
            lineHeight: 1.5
          }}
        >
          {message}
        </DialogContentText>
      </DialogContent>

      {/* Actions */}
      <DialogActions sx={{ p: 0, mt: 3, justifyContent: 'flex-end', gap: 2 }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          sx={{
            borderRadius: 1,
            textTransform: 'none',
            fontSize: 14,
            px: 2,
            color: theme.palette.text.primary,
            borderColor: theme.palette.text.primary,
            '&:hover': {
              borderColor: theme.palette.warning.main,
              backgroundColor: theme.palette.warning.light
            }
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: confirmButtonColor || theme.palette.error.main,
            borderRadius: 1,
            textTransform: 'none',
            fontSize: 14,
            px: 2,
            color: theme.palette.common.white,
            '&:hover': {
              backgroundColor: confirmButtonColor
                ? confirmButtonColor
                : theme.palette.error.dark,
              opacity: 0.9
            }
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
